export { OrganicContact as Contact } from './OrganicContact/OrganicContact';
export { OrganicPortfolio as Portfolio } from './OrganicPortfolio/OrganicPortfolio';
export { OrganicServices as Services } from './OrganicServices/OrganicServices';
export { OrganicTeam as Team } from './OrganicTeam/OrganicTeam';
export { OrganicHome as Home } from './OrganicHome/OrganicHome';
export { OrganicAbout as About } from './OrganicAbout/OrganicAbout';
export { OrganicPackages as Packages } from './OrganicPackages/OrganicPackages';
